import { render, staticRenderFns } from "./LeaguePage.vue?vue&type=template&id=45e73a62&scoped=true&"
import script from "./LeaguePage.vue?vue&type=script&lang=js&"
export * from "./LeaguePage.vue?vue&type=script&lang=js&"
import style0 from "./LeaguePage.vue?vue&type=style&index=0&id=45e73a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e73a62",
  null
  
)

export default component.exports